<mat-form-field
  class="w-full"
  subscriptSizing="dynamic"
  [appearance]="appearance"
  [ngClass]="{ compact: compact }"
  [floatLabel]="placeholder() ? 'always' : 'auto'"
>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [formControl]="selected"
    [compareWith]="compareFn"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
  >
    <mat-select-trigger [ngClass]="{ 'text-xs': compact }">
      @if (displayName$ | async; as name) {
        {{ name }}
      }
    </mat-select-trigger>
    @if (allowEmpty) {
      <mat-option [value]="undefined">{{ emptyLabel() }}</mat-option>
    }
    <mat-option
      *ngFor="let staffer of staff$ | async; trackBy: trackByStaffer"
      [value]="staffer"
    >
      <pr-staffer-display [staffer]="staffer" />
    </mat-option>
  </mat-select>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
